module.exports = __webpack_public_path__ + "static/andrew-ng-5cc6f68fe9e1010d2e0086a01089382a.jpg";